<template>
    <div>
        <div class="mt-2 pb-5">
            <div class="d-flex">
                <div class="btn-home mb-4 ms-auto">
                    <!-- <button type="button" class="btn btn-outline-main" @click="returnHome">
                        <i class="fas fa-home-lg-alt"></i> Inicio
                    </button> -->
                </div>
            </div>
            <Home v-if="page == 'home'" @returnHome="returnHome" @changePage="changePage" />
            <Medicamentos v-if="page == 'medicamentos'" @changePage="changePage" @returnHome="returnHome"/>
            <Activos v-if="page == 'activos'" @changePage="changePage" @returnHome="returnHome"/>
        </div>
        <SweetAlert :swal="swal" ref="SweetAlert" />
    </div>
</template>

<script>
import { mapActions } from "vuex";
import SweetAlert from '@/components/shared/SweetAlert/SweetAlert.vue';
import Medicamentos from "@/components/Logistica/pages/Movimientos/Medicamentos.vue";
import Activos from "@/components/Logistica/pages/Movimientos/Activos.vue";
import Home from '../pages/Movimientos/Home.vue'

export default {

    name: "logis-maintenance",
    components: {
        SweetAlert,
        Home,
        Medicamentos,
        Activos
    },
    data() {
        return {
            swal: null,
            page: "home",
            providers: [],
            products: [],
        }
    },
    created() {
        this.mtdGetData();
    },
    methods: {
        ...mapActions(["get", "post"]),

        changePage: function (page) {
            this.page = page;
        },
        returnHome: function () {
            this.$emit("returnHome");
        },
        mtdGetData: function () {
            this.get({
                url: this.$store.getters.get__url + "/logistics/getProviders",
                token: this.$store.getters.get__token,
            })
                .then((response) => {
                    this.providers = response.data;
                })
                .catch((errors) => {
                    this.$refs.SweetAlert.showError(errors);
                });
        },
    }
}
</script>

<style scoped>
.h4-borde {
    border-radius: 50px;
}

#myTabContent {
    border: #43517A 1.9px solid;
}

.item-button {
    background: #A9A9A9 !important;
    border-radius: 10px 10px 0px 0px;
    border: none !important;
    color: white !important;
    width: 155px;
}

.item-button1 {
    background: #A9A9A9 !important;
    border-radius: 10px 10px 0px 0px;
    border: none !important;
    color: white !important;
    width: 160px !important;
}

.nav-link:hover {
    background: #43517A !important
}

.active {
    background-color: #43517A !important;

}

.nav-item {
    width: 159.39px;
}
</style>